import { render, staticRenderFns } from "./V2OrderList.vue?vue&type=template&id=5db1d41a&scoped=true&"
import script from "./V2OrderList.vue?vue&type=script&lang=js&"
export * from "./V2OrderList.vue?vue&type=script&lang=js&"
import style0 from "./V2OrderList.vue?vue&type=style&index=0&id=5db1d41a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db1d41a",
  null
  
)

export default component.exports